
export class PwaService {
    // BeforeInstallPromptEvent
    public installPromptEvent: null | Event = null;

    private installHook = (e: Event) => {}

    init() {
        if (this.installPromptEvent) return;

        const installHook = (e: Event) => {
            this.installPromptEvent = e;
            this.installPromptEvent.preventDefault();
        }
        this.installHook = installHook;
        window.addEventListener('beforeinstallprompt', installHook);
    }

    unload() {
        window.removeEventListener('beforeinstallprompt', this.installHook)
    }

    get isInPwa() {
        return window.matchMedia('(display-mode:minimal-ui) or (display-mode:standalone)').matches;
    }
}

export const pwaService = new PwaService();

export function trackParam(sourceType: string) {
    return {
        module_type: 'EUREKA',
        event_type: 'SS Pwa',
        source_type: sourceType,
    };
}
